// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `image-cropper div.source-image {
  border: 1px solid #d3d3d3;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/profile/change-password-modal.component.less"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ","sourcesContent":["image-cropper div.source-image {\n    border: 1px solid #d3d3d3;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
